import { authClient, getServiceURL } from '@/utils'

const uploadResource = (domain, entity, file, onUploadProgress) => {
	const formData = new FormData()
	formData.append('file', file)
	return authClient.post(`${getServiceURL('images')}/v1/files/temp`, formData, {
		params: { domain, entity },
		headers: { ContentType: 'multipart/form-data' },
		onUploadProgress,
		timeout: 60000
	})
}

export default { uploadResource }
